import { render } from "./IconWarehouse.vue?vue&type=template&id=cd0aec74"
import script from "./IconWarehouse.vue?vue&type=script&lang=ts"
export * from "./IconWarehouse.vue?vue&type=script&lang=ts"
script.render = render

export default script